import { Component } from '@angular/core';
import { Field } from '@intersystems/isc-form';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-isc-form-field-html-hint-wrapper',
  templateUrl: './isc-form-field-html-hint-wrapper.component.html',
  styleUrls: ['./isc-form-field-html-hint-wrapper.component.scss'],
})
export class IscFormFieldHtmlHintWrapperComponent extends FieldWrapper {
  field: Field;
}
